import React, { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from '@tanstack/react-router';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/layout/Header';
import SessionRevokedModal from './components/layout/SessionRevokedModal';
import { applyPendingClear } from './hooks/usePersistedMapState';
import './App.css';

const PageLoader = () => (
  <div style={{
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    height: '100vh', color: '#888', fontSize: '18px'
  }}>
    Cargando...
  </div>
);

function App() {
  const location = useLocation();
  const mapRoutes = ['/maininteractivemap', '/eddies', '/forecast', '/mascara', '/vientos-olas', '/modelos_predictivos/jurel', '/modelos_predictivos/especie', '/zonas_pesca_ia/jurel'];
  const isMapPage = mapRoutes.includes(location.pathname);
  const isLandingPage = location.pathname === '/';
  const isServiceSelectionPage = location.pathname === '/select-service';
  const isZonasPescaIaHub = location.pathname.startsWith('/zonas_pesca_ia') && !isMapPage;
  const isDashboardPage = location.pathname.startsWith('/dashboard_enso_peru') || location.pathname === '/dashboard_hub' || location.pathname === '/dashboard_estado_mar';

  useEffect(() => { applyPendingClear(); }, []);

  const getContentClass = () => {
    if (isMapPage) return "app-content-map";
    if (isLandingPage) return "app-content-landing";
    if (isZonasPescaIaHub) return "app-content-landing";
    if (isDashboardPage) return "app-content-dashboard";
    if (isServiceSelectionPage) return "app-content-service-selection";
    return "app-content-default";
  };

  return (
    <div className="app-container">
      <SessionRevokedModal />
      {!isDashboardPage && <Header />}
      <main className={getContentClass()}>
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}

export default App;
